export enum MarketplaceType {
  DIRECT_DOWNLOAD = 'DIRECT_DOWNLOAD', TITLE_IMPORT = 'TITLE_IMPORT'
}
